import { render, staticRenderFns } from "./HsaStoreWidget.vue?vue&type=template&id=164c6116&scoped=true"
import script from "./HsaStoreWidget.vue?vue&type=script&lang=ts"
export * from "./HsaStoreWidget.vue?vue&type=script&lang=ts"
import style0 from "./HsaStoreWidget.vue?vue&type=style&index=0&id=164c6116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c6116",
  null
  
)

export default component.exports